import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import TaxaRegulacaoAPI from "@/api/taxaRegulacao.api";
import {
  ListaDaesRegulacaoResponse,
  ReemissaoResponse
} from "@/models/taxaRegulacao";

const taxaRegulacaoAPI = new TaxaRegulacaoAPI();

const listarPagos = (
  transportadoraId: number,
  cnpj: string
): AxiosObservable<ListaDaesRegulacaoResponse> => {
  return taxaRegulacaoAPI.listarPagos(transportadoraId, cnpj);
};

const reemitir = (
  transportadoraId: number,
  cnpj: string,
  numeroDae: string,
  novaDataVencimento: string
): AxiosObservable<ReemissaoResponse> => {
  return taxaRegulacaoAPI.reemitir(
    transportadoraId,
    cnpj,
    numeroDae,
    novaDataVencimento
  );
};

export default {
  listarPagos,
  reemitir
};
